function initMap() {

	var myLatLng = {
		lat: 52.057987,
		lng: -1.337673
	};

	var map = new google.maps.Map(document.getElementById('map'), {
		zoom: 14,
		center: myLatLng,
		scrollwheel: false,
		mapTypeControl: false,
		zoomControl: true,
		streetViewControl: false
	});

	var marker = new google.maps.Marker({
		position: myLatLng,
		map: map,
		title: "St Michael's Care"
	});

	google.maps.event.addListener(map, 'click', function(event) {
		this.setOptions({
			scrollwheel: true
		});
	});
	google.maps.event.addListener(map, 'mouseout', function(event) {
		this.setOptions({
			scrollwheel: false
		});
	});
}

$('ul.nav li:nth-child(5) a').addClass('active');

// Validation
$("#sky-form").validate({
	// Rules for form validation
	rules: {
		name: {
			required: true
		},
		email: {
			required: true,
			email: true
		},
		message: {
			required: true,
			minlength: 10
		},
		subject: {
			required: true
		},
		captcha: {
			required: true,
			remote: 'sky-forms/version-2.0.4/captcha/process.php'
		}
	},

	// Messages for form validation
	messages: {
		name: {
			required: 'Please enter your name',
		},
		email: {
			required: 'Please enter your email address',
			email: 'Please enter a VALID email address'
		},
		message: {
			required: 'Please enter your message'
		},
		subject: {
			required: 'Please enter your subject'
		},
		captcha: {
			required: 'Please enter characters',
			remote: 'Correct captcha is required'
		}
	},

	// Ajax form submition                  
	submitHandler: function(form) {
		$(form).ajaxSubmit({
			beforeSend: function() {
				$('#sky-form button[type="submit"]').attr('disabled', true);
			},
			success: function() {                                            
				var $enquiryEmail = $('#email').val();
				var $enquiryType = $('select#enquiry option:selected').val();
				document.cookie = "email=" + $enquiryEmail + "; max-age=31556926; path=/";
				dataLayer.push({'event': 'Contact_Form_Submit', 'email': $enquiryEmail, 'enquiryType': $enquiryType});
				
				$("#sky-form").addClass('submited');
			}
		});
	},

	// Do not change code below
	errorPlacement: function(error, element) {
		error.insertAfter(element.parent());
	}
});